export { default } from "./Categoria";
